import Image from 'core/display/Image'
import { enableTap } from 'core/handlers/TapHandler'
import { ButtonManager } from 'managers/ButtonManager'
import { KeyboardManager } from 'managers/KeyboardManager'
import { signal } from 'services/SignalsService'

export default class BetButton {
  constructor(data) {
    this._data = data
    this.image = new Image(data)
    this.image.calculateGlow()
    this.name = data.name.split('-')[0]
    this.payload = parseInt(data.name.split('-')[1])
    this.id = `BET:${this.name}`
    this.state = ''
    this.bets = game.models.BetModel.getList()
    this.createSignal()

    KeyboardManager.register({ id: this.id, payload: this.payload, tap: this.tap.bind(this) })
    enableTap(this.image, this.tap.bind(this))
    return this.image
  }

  createSignal() {
    const self = this
    signal.on('MODEL:BET', function () {
      if (self.payload > self.bets.length - 1){
        self.image.images[0].visible = false
        self.image.images[1].visible = false
      }
      else {
        self.image.images[0].visible =    self.payload !== game.models.BetModel.getID()
        self.image.images[1].visible =    self.payload === game.models.BetModel.getID()
      }
    })
  }

  tap(){
    ButtonManager.dispatch(this.id, this._data.deselect && this.payload === this.state ? '' : this.payload)
  }
}
